export const ButtonFields = [
  {
    name: 'text',
    type: 'text',
    required: true,
  },
  {
    name: 'url',
    type: 'url',
    required: true,
  },
  {
    name: 'newTab',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Default to false',
  },
];

export const TitleFields = [
  {
    name: 'content',
    helperText: 'Type the desired title.',
    type: 'text',
  },
  {
    name: 'titleHTMLTag',
    type: 'string',
    defaultValue: 'h2',
    helperText: 'Defaults to h2',
    enum: ['h1', 'h2', 'h3'],
  },
  {
    name: 'titleSize',
    type: 'string',
    helperText: 'Select the title size. Defaults to the corresponding HTML tag.',
    enum: ['extraLarge', 'large', 'medium', 'small'],
  },
  {
    name: 'titleWeight',
    type: 'string',
    defaultValue: 'normal',
    helperText: 'Select the title weight. Default is normal',
    enum: ['normal', 'bold'],
  },
];

export interface ITitle {
  content: string;
  titleHTMLTag?: 'h1' | 'h2' | 'h3';
  titleSize?: 'extraLarge' | 'large' | 'medium' | 'small';
  titleWeight?: 'light' | 'normal' | 'medium' | 'bold' | 'black';
}

export const MarginField = {
  name: 'margin',
  type: 'boolean',
  defaultValue: false,
  helperText: 'Turn on to add margin to the bottom of the component',
};

export const AnchorField = {
  name: 'anchorLinkID',
  friendlyName: 'Anchor Link ID',
  type: 'string',
  helperText: 'Anchor link can only contain letters, numbers, dashes, or underlines',
  regex: {
    pattern: '^[a-zA-Z0-9-_]+$',
    options: 'g',
    message: 'Anchor link can only contain letters, numbers, dashes, or underlines',
  },
};
